// extracted by mini-css-extract-plugin
module.exports = {"appNavigation":"room__styles__appNavigation___3QIT4n","flexibleContainer":"room__styles__flexibleContainer___1-JMUa","empty":"room__styles__empty___3_ig7O"};